import React from 'react';
import { Col, Row } from 'antd';
import PropTypes from 'prop-types';
import OnTraccrButton from '../common/buttons/OnTraccrButton';

export default function BoardCardRestore({
  selectedCard,
  templateTitle,
  draftCard,
  onRestoreDraftCard,
}) {
  const text = selectedCard ? selectedCard.title : `Create ${templateTitle} card`;

  return (
    <Row gutter={10} align="middle" style={{ maxWidth: '100%' }}>
      <Col>
        {text}
      </Col>
      <Col>
        <div style={{ fontSize: 12, fontWeight: 200 }}>
          You have a saved draft for this card
        </div>
      </Col>
      <Col>
        <OnTraccrButton
          onClick={() => onRestoreDraftCard(draftCard)}
          title="Restore"
        />
      </Col>
    </Row>
  );
}

BoardCardRestore.propTypes = {
  selectedCard: PropTypes.shape({
    title: PropTypes.string,
  }),
  templateTitle: PropTypes.string.isRequired,
  draftCard: PropTypes.shape({}),
  onRestoreDraftCard: PropTypes.func.isRequired,
};

BoardCardRestore.defaultProps = {
  selectedCard: null,
  draftCard: null,
};
